import { Injectable } from "@angular/core";
import { CryptoEncryptionService } from "./crypto-encryption.service";
import { Buffer } from "buffer";
import { USER_STORE_DATA_ENUM } from "./user-services/user-types";

@Injectable({
    providedIn: "root",
})
export class StoreService {
    constructor(private encrypt: CryptoEncryptionService) {}

    set(obj: { key: string; value: any }) {
        let key = Buffer.from(obj.key, "binary").toString("base64");
        let value = this.encrypt.encryptionAES(obj.value);
        localStorage.setItem(key, value);
        return true;
    }
    get(key: string) {
        key = Buffer.from(key, "binary").toString("base64");
        let getData = localStorage.getItem(key);
        if (getData != null) {
            let value = this.encrypt.decryptionAES(getData);
            if (value && value != "") {
                return value;
            }
        }
        return null;
    }
    remove(key: string) {
        key = Buffer.from(key, "binary").toString("base64");
        localStorage.removeItem(key);
        return true;
    }
    clearAuthStore() {
        const getDKey = (key: string) => {
            return Buffer.from(key, "binary").toString("base64");
        };
        localStorage.removeItem(getDKey("token"));
        localStorage.removeItem(getDKey("refreshToken"));
        localStorage.removeItem(getDKey("m-token"));
        localStorage.removeItem(getDKey("applicationId"));
        localStorage.removeItem(getDKey("unAuthDetails"));
        localStorage.removeItem(getDKey("flyyToken"));
        localStorage.removeItem(getDKey("flyyDeviceId"));
        localStorage.removeItem(getDKey("customerDetails"));
        localStorage.removeItem(getDKey("fcmToken"));
        localStorage.removeItem(getDKey("cKycAttempt"));
        localStorage.removeItem(getDKey("notRegDetails"));
        localStorage.removeItem(getDKey("loanCount"));
        localStorage.removeItem(getDKey("mobileNumber"));
        localStorage.removeItem(getDKey("authMobileNumber"));
        localStorage.removeItem(getDKey("employment"));
        localStorage.removeItem(getDKey("existingCompanyData"));
        localStorage.removeItem(getDKey("cKycAttempt"));
        localStorage.removeItem(getDKey("ckycDataMobile"));
        localStorage.removeItem(getDKey("ckycDataPan"));
        // localStorage.removeItem(getDKey("latitude"));
        // localStorage.removeItem(getDKey("longitude"));
        localStorage.removeItem(getDKey("marketingAPICalled"));
        localStorage.removeItem(getDKey("isGeneratedAuthToken"));
        localStorage.removeItem(getDKey("stateOfEditEmailOtp"));
        localStorage.removeItem(getDKey("stateOfUpdateEmail"));
        localStorage.removeItem(getDKey("stateOfUpdateEmailOtp"));
        localStorage.removeItem(getDKey("unreadNotification"));
        localStorage.removeItem(getDKey("workEmailOtpVerify"));
        localStorage.removeItem(getDKey("intRate"));
        localStorage.removeItem(getDKey("repaymentDate"));
        localStorage.removeItem(getDKey("congIntPopup"));

        localStorage.removeItem(getDKey("softApprovalRoute"));
        localStorage.removeItem(getDKey("planReadyRoute"));
        localStorage.removeItem(getDKey("everyDayLifeRoute"));
        localStorage.removeItem(getDKey("habitReward"));

        localStorage.removeItem(getDKey(USER_STORE_DATA_ENUM.isUserTrackedInNetCore));
        localStorage.removeItem(getDKey(USER_STORE_DATA_ENUM.loanDetails));

        // KLQ
        localStorage.removeItem(getDKey("referralSeen"));
        localStorage.removeItem(getDKey("panNumber"));
        localStorage.removeItem(getDKey("stage"));
        localStorage.removeItem(getDKey("dob"));
        localStorage.removeItem(getDKey("email"));
    }

    toUrlSafe(value: string): string {
        return value.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
    }

    fromUrlSafe(value: string): string {
        value = value.replace(/-/g, "+").replace(/_/g, "/");

        // Add removed padding back
        while (value.length % 4 !== 0) {
            value += "=";
        }

        return value;
    }

    encryptParam(raw: string): string {
        const encrypted = this.encrypt.encryptionAES(raw);
        return this.toUrlSafe(encrypted);
    }

    decryptParam(raw: any): string | null {
        try {
            const base64 = this.fromUrlSafe(raw);
            return this.encrypt.decryptionAES(base64);
        } catch {
            return null;
        }
    }
}
